/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import formattingRulesParameters from '@jira/business__shared-components-conditional-formatting-sidebar/src/ui/format-rules/__generated__/FormatRulesQuery$parameters';
import type { FormatRulesQuery } from '@jira/business__shared-components-conditional-formatting-sidebar/src/ui/format-rules/__generated__/FormatRulesQuery.graphql';
import parameters from './__generated__/JiraBusinessListEmbedAppQuery$parameters.ts';
import type { JiraBusinessListEmbedAppQuery } from './__generated__/JiraBusinessListEmbedAppQuery.graphql.ts';

const FORMAT_RULES_FIRST = 20;

type ListEmbedEntryPointComponent = EntryPointComponent<
	{
		listEmbedQuery: JiraBusinessListEmbedAppQuery;
		formattingRulesQuery: FormatRulesQuery;
	},
	{},
	{},
	{}
>;

export const listEmbedEntryPoint: EntryPoint<ListEmbedEntryPointComponent, EntryPointRouteParams> =
	createEntryPoint({
		root: JSResourceForUserVisible<ListEmbedEntryPointComponent>(
			/* webpackChunkName: "async-business-list-embed-entrypoint" */ './JiraBusinessListEmbedApp.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: ({ context, tenantContext: { cloudId } }: EntryPointRouteParams) => {
			const projectKey = context.match.params.projectKey;

			if (projectKey == null) {
				throw new Error('Project key missing');
			}

			return {
				queries: {
					listEmbedQuery: {
						options: {
							fetchPolicy: 'store-and-network' as const,
						},
						parameters,
						variables: {
							cloudId,
							projectKey,
						},
					},
					formattingRulesQuery: {
						parameters: formattingRulesParameters,
						variables: {
							projectKey,
							cloudId,
							first: FORMAT_RULES_FIRST,
						},
						options: {
							fetchPolicy: 'network-only' as const,
						},
					},
				},
			};
		},
	});
